import callAPiBase from './base';

const attendantsApi = {
  list: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `api/attendants`,
      method: 'GET',
      useToken: true,
      params,
    }),
  get: ({ ID }: { ID: string }) =>
    callAPiBase({
      endpoint: `/api/attendant?ID=${ID}`,
      method: 'GET',
      useToken: true,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/api/attendant',
      method: 'POST',
      useToken: true,
      data,
    }),
  update: ({ ID, data }: { ID: string; data: object }) =>
    callAPiBase({
      endpoint: `/api/attendant?ID=${ID}`,
      method: 'PUT',
      useToken: true,
      data,
    }),
  delete: ({ ID }: { ID: string }) =>
    callAPiBase({
      endpoint: `/api/attendant?ID=${ID}`,
      method: 'DELETE',
      useToken: true,
    }),
};

export { attendantsApi };
export default attendantsApi;
